// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"157ce4a4","150":"78f9dc5f","281":"e0b7bfa6","343":"ec129129","406":"af772f3e","953":"b19958fd","978":"927ef4b7"}[chunkId] + ".chunk.js";
};